import { createFileRoute, Link } from '@tanstack/react-router'
import { GenericAlert } from '@/components/generic-alert'
import { Button } from '@/components/ui/button'
import { ChevronRight } from 'lucide-react'
import * as React from 'react'
import Overview from '@/views/overview'

export const Route = createFileRoute(
  '/_authenticated/organization/$organizationId/_non_installer/',
)({
  component: RouteComponent,
  notFoundComponent: NotFoundComponent,
  beforeLoad: () => ({ removeContentPadding: true }),
})

function RouteComponent() {
  const { organizationId } = Route.useParams();
  return <Overview organizationId={organizationId} />
}

function NotFoundComponent() {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center">
      <GenericAlert>
        <p className="text-xl mb-4">Organization not found!</p>
        <Button>
          <Link to="/organization" className="flex flex-row gap-2 items-center">
            Go home
            <ChevronRight />
          </Link>
        </Button>
      </GenericAlert>
    </div>
  )
}
